/**
 * Deployed backend (Azure) and production SPA origin.
 * Import from here instead of hardcoding URLs in services.
 */
export const environment = {
  production: true,
  apiBaseUrl: 'https://procurement-portal-g9h9b6fcffgxazc7.eastus2-01.azurewebsites.net/api',
  /** SPA URL used for MSAL redirect and similar */
  appOrigin: 'https://vendorportal.unipet.co.tt',
};
